
import { butter } from "../plugins/buttercms";
import CalHeadingPara from "../components/cal-heading-para-section.vue";
export default {
  name: "Fine-Print",
  components: { CalHeadingPara },
  data() {
    return {
      pageData: {},
    };
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "fine_print_page",
        "the-fine-print",
        {
          locale: this.$i18n.locale,
          timeout: 10000
        }
      );
      this.pageData = page?.data.data.fields;
    } catch (error) {
      console.error(error);
    }
  },
};
